import {IUOMPolicy, IUOMPolicyOptions, UOM} from "./PA.MD.Services.IF";
import {WB_PlanTypeRow} from "../PA.Core/PAdbSchemaRows";
import * as AsyncLock from "async-lock";
import {PAdbContext} from "../PA.Core/PAdbContext";
import * as _ from "lodash"
import {esWB_Plan_Type} from "../PA.Core/PAdbSchema";

const emptyUOM: UOM = {
    bCurrency: false,
    CurrencyCode: "",
    bUOM: false,
    UOMCode: ""
}

export class PlanTypeUOMPolicy
    implements IUOMPolicy
{
    private static dctPlanType: {[wbId: number]: WB_PlanTypeRow} = {}
    private static lock: AsyncLock = new AsyncLock()
    private static dbContext: PAdbContext = undefined

    private sPolicyId: string
    private bCurrencyMode: boolean

    constructor(bCurrencyMode: boolean){

        this.bCurrencyMode = !!bCurrencyMode
        if(bCurrencyMode)
            this.sPolicyId = "PlanTypeCurrency"
        else
            this.sPolicyId = "PlanTypeVolume"
    }

    get PolicyId(): string { return this.sPolicyId }

    async getUOM(options: IUOMPolicyOptions): Promise<UOM> {
        const self = this
        let opts = options || {}

        return await PlanTypeUOMPolicy.lock.acquire("global", (done) => {
            //--
            if(!_.isEmpty(opts.WB_PlanTypeRow)){
                let wbId = opts.WB_PlanTypeRow.cif.WB_PLANM_ID
                if(_.isNumber(wbId) && (!(wbId in PlanTypeUOMPolicy.dctPlanType)))
                    PlanTypeUOMPolicy.dctPlanType[wbId] = opts.WB_PlanTypeRow

                let planMRow = opts.WB_PlanTypeRow
                if(self.bCurrencyMode)
                    done(undefined, {bCurrency: true, CurrencyCode:  planMRow.cif.CURRENCY, bUOM: false, UOMCode: ""})
                else
                    done(undefined, {bUOM: true, UOMCode: planMRow.cif.QUANTITY_UOM, bCurrency: false, CurrencyCode: ""})
                return
            }

            if(_.isNumber(opts.WB_PLANM_ID)){
                let wbId = opts.WB_PLANM_ID
                if(wbId in PlanTypeUOMPolicy.dctPlanType){
                    let planMRow = PlanTypeUOMPolicy.dctPlanType[wbId]
                    if(self.bCurrencyMode)
                        done(undefined, {bCurrency: true, CurrencyCode:  planMRow.cif.CURRENCY, bUOM: false, UOMCode: ""})
                    else
                        done(undefined, {bUOM: true, UOMCode: planMRow.cif.QUANTITY_UOM, bCurrency: false, CurrencyCode: ""})
                    return

                } else {
                    //Lookup and place in cache
                    if(!PlanTypeUOMPolicy.dbContext)
                        PlanTypeUOMPolicy.dbContext = new PAdbContext()
                    PlanTypeUOMPolicy.dbContext.find(esWB_Plan_Type, wbId)
                        .then((planMRow: WB_PlanTypeRow) => {
                            if(_.isEmpty(planMRow)){
                                done(Error("Unknown PlanType Id"))
                                return
                            }

                            let wbId = planMRow.cif.WB_PLANM_ID
                            if(!(wbId in PlanTypeUOMPolicy.dctPlanType))
                                PlanTypeUOMPolicy.dctPlanType[wbId] = planMRow

                                if(self.bCurrencyMode)
                                    done(undefined, {bCurrency: true, CurrencyCode:  planMRow.cif.CURRENCY, bUOM: false, UOMCode: ""})
                                else
                                    done(undefined, {bUOM: true, UOMCode: planMRow.cif.QUANTITY_UOM, bCurrency: false, CurrencyCode: ""})
                                return
                        })
                        .catch((err) => {
                            done(err)
                        })

                }
            }

            done(undefined, emptyUOM)

        })

    }





}